// extracted by mini-css-extract-plugin
module.exports = {"fas-icon":"fas-icon--0cf7b3","fasIcon":"fas-icon--0cf7b3"};